import { LayerType } from '@/views/map/layers/types';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { SpeciesLegend } from './SpeciesLegend';
import type { SelectionProps } from './MapLayerOption';
import { MapLayerOption } from './MapLayerOption';

export const SpeciesLayerOption = (props: SelectionProps) => {
  const isSmallScreen = useSmallScreen();

  return (
    <MapLayerOption
      title="By tree species"
      value={LayerType[LayerType.tree_species]}
      {...props}
    >
      {isSmallScreen &&
        props.selected === LayerType[LayerType.tree_species] && (
          <SpeciesLegend />
        )}
    </MapLayerOption>
  );
};
